import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const somnia = {
  id: 5031,
  name: "Somnia",
  nativeCurrency: {
    decimals: 18,
    name: "SOMI",
    symbol: "SOMI",
  },
  rpcUrls: {
    default: { http: ["https://api.infra.mainnet.somnia.network/"] },
  },
}

export const somniaConfig: StaticEthereumBlockchainConfig = {
  name: "Somnia",
  blockchain: Blockchain.SOMNIA,
  isEvm: true,
  testnet: false,
  isTestnet: false,
  chainId: 5031,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  chainName: "Somnia",
  icon: "/images/blockchains/somnia.svg",
  unionApi: "https://api.rarible.org",
  basePath: "https://somnia-api.rarible.org",
  exchange: {
    v2: "0x34988c0b2Ba9095F4f13aD19070d6776c6107Cd0",
    wrapper: "0x49373172e5848217B85CFe7E078606e49534886B",
  },
  blockExplorers: [
    {
      url: "https://shannon-explorer.somnia.network",
      icon: "/images/scanner.svg",
      adress: "https://shannon-explorer.somnia.network/address/${adrress}",
    },
  ],
  rpcUrls: [
    {
      url: "https://api.infra.mainnet.somnia.network/",
      isPublic: true,
    },
  ],
  privateRpcNodeSlug: "somnia-node",
  transferProxies: {
    nft: "0x008B1d40013f147EBfc43502a8d27043F4a86260",
    erc721Lazy: "0x2bC93750cffaFA586f00939A76f5aaB362D2F442",
    erc20: "0xD5A357fb04e2E9e5231AF6098767F794eaaC4b5a",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("SOMNIA:0x0000000000000000000000000000000000000000"),
    symbol: "SOMI",
    name: "SOMI",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("SOMNIA:0x046ede9564a72571df6f5e44d0405360c0f4dcab"),
    symbol: "WSOMI",
    name: "WSOMI",
    decimals: 18,
  },
  addFundsLink: "https://somnia.network",
  hasStabilityProtocol: false,
  viem: somnia,
}

export const getSomniaConfig = (): StaticEthereumBlockchainConfig =>
  somniaConfig
